import { fetchRoomCanAccess } from '@/api/fetchRoomCanAccess'
import { QUERY_KEY } from '@/constants/queryKey'
import { useQueryClient } from 'react-query'

const useCheckRoomCanAccess = () => {
  const queryClient = useQueryClient()

  const checkRoomCanAccess = async (roomId: string) => {
    return queryClient.fetchQuery([QUERY_KEY.FETCH_ROOM_CAN_ACCESS, { roomId }], () => fetchRoomCanAccess({ roomId }))
  }

  return { checkRoomCanAccess }
}

export default useCheckRoomCanAccess
